export const TEST_ID = 'weatherValidationCard';

export const STATUS_LABEL_OK = 'All pass';

export const STATUS_LABEL_WARN = 'Advisory';

export const STATUS_LABEL_ERROR = 'Failing';

export const PASS_INDICATOR = '✓';

export const FAIL_INDICATOR = '✗';
